import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import CommonMessages from '~/core/commonMessages';

import { Wrapper } from './styles';

export const NeutralSiteIndicator: FC = () => (
    <Wrapper>
        <FormattedMessage {...CommonMessages.gameLocationDescriptions.long.neutralSite} />
    </Wrapper>
);
